import { InsightTag } from '@ecosystem/newron-client-collections/build/shared/types';
import { getBaseTimePeriodForMATAndYTD, getPeriodicityForMATAndYTD } from '@utils/PeriodUtils';
import { capitalizeEachWord } from '@utils/StringUtils';
import {
  addAllProductGroupFilter,
  getGeneralCollectionInsightTags,
  getIsUsingCollectionLiveData,
  getPeriodLabel,
} from '@utils/collectionUtils/CollectionUtils';
import { ProductsLeaderboardDoubleBarChartInsight } from './Model';
import { getCountryCodes } from '@utils/CountryUtils';

export const getProductsDoubleBarChartInsightInfoTags = async (
  insight: ProductsLeaderboardDoubleBarChartInsight,
): Promise<InsightTag[]> => {
  const {
    apiParams: { appliedFilters, periodType, period, comparisonPeriod, clientId, countryId, productType, productGroup },
    selectedGrowthType,
    selectedKpiOption,
    retailerClientName,
    collectionDataType,
  } = insight;

  const baseTimePeriod = getBaseTimePeriodForMATAndYTD(period, periodType);
  const { periodicity } = getPeriodicityForMATAndYTD(baseTimePeriod, periodType);

  const periodLabel = await getPeriodLabel({
    clientId,
    periodicity,
    baseTimePeriod,
    comparisonPeriod,
    countryIds: getCountryCodes([{ id: countryId }]),
    productType,
    collectionDataType: getIsUsingCollectionLiveData(period, collectionDataType) ? 'live' : collectionDataType,
    productGroups: [{ label: productGroup[0], value: productGroup[0] }],
  });

  const baseTags = getGeneralCollectionInsightTags({
    periodType: periodicity,
    comparisonPeriod: comparisonPeriod.toString(),
    selectedGrowthType: selectedGrowthType,
    appliedFilters: addAllProductGroupFilter(appliedFilters),
    period: periodLabel,
    retailerClientName: retailerClientName,
  });

  const otherTags = [
    {
      key: 'KPI',
      value: capitalizeEachWord(selectedKpiOption.label.toString()),
    },
  ];

  return [...baseTags, ...otherTags];
};
